import { createSelector } from 'reselect';

export const getComponentState = state => state.search;

export const getItems = createSelector(
    getComponentState,
    (state) => state.items
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getSearch = createSelector(
    getComponentState,
    (state) => state.search
);
export const getSearchType = createSelector(
    getComponentState,
    (state) => state.searchType
);
export const getProductType = createSelector(
    getComponentState,
    (state) => state.productType
);